var sidebarSelector = '.js-sidebar__vacancyDetail',
    $sidebar = $(sidebarSelector),
    buttonSelector = '.js-sidebar__summaryToogle',
    $button = $(buttonSelector),
    summarySelector = '.js-sidebar__summary',
    $summaryBox = $(summarySelector);

/**
 * set Bindhandlers.
 */

var bindHandlers = function bindHandlers() {
    handleStickySidebar();

    if ($button.length) {
        $button.on( "click", function() {
            $button.toggleClass("c-sidebar__summaryToogleOpen")
            $button.toggleClass("c-sidebar__summaryToogle");
            $summaryBox.fadeToggle( "fast", function() {
                $summaryBox.toggleClass("u-hidden@tablet-and-down");
            });
        });
    }
}

function handleStickySidebar(){
    var $stickyrStopper = $('.js-contact-box-with-img');
    if (!!$sidebar.offset()) {
        
        const $viewPortW = window.innerWidth;
        const $isMobile = $viewPortW < 720;

        var generalSidebarHeight = $sidebar.innerHeight();
        var stickyTop = $sidebar.offset().top - $('.js--header').height();
        var stickyStopperPosition = $stickyrStopper.offset().top;
        var stopPoint = stickyStopperPosition - generalSidebarHeight;

        $(window).scroll(function(){
            var windowTop = $(window).scrollTop();

            if (!$isMobile) {
                if (stopPoint < windowTop + 180) {
                    $sidebar.css({ 
                        position: 'relative', 
                        top: $sidebar.position().top
                    });
                } else if (stickyTop < windowTop) {
                    $sidebar.css({ 
                        position: 'fixed', 
                        top: $('.js--header').height() + 40
                    });
                } else {
                    $sidebar.css({ position: 'absolute', top: 'initial', width: '207px' });
                }
            }

            if ($isMobile) {
                if (stickyTop < windowTop) {
                    $sidebar.css({
                        position: 'fixed',
                        top: 55,
                        left: 0,
                        right: 0,
                        zIndex: 7
                    });
                } else {
                    $sidebar.css({ position: 'relative', top: 'initial' });
                }             
            }
        });
  
    }
}


/**
 * check if we need to initialise
 */
$(bindHandlers);